import cx from 'clsx';
import * as React from 'react';

import { GroupsListContainer } from './GroupsList';
import { GroupsHeaderContainer } from './Header';
import * as styles from './styles/groupsSection.css';

export interface IGroupsProps {
  isActiveScreen?: boolean;
}

export function GroupsSection({ isActiveScreen = true }: IGroupsProps) {
  return (
    <div className={cx(styles['groups'], !isActiveScreen && styles['hide'])} data-testid="GroupsSection">
      <GroupsHeaderContainer />
      <GroupsListContainer />
    </div>
  );
}
